import './SearchableSelectArea.scss';
import clsx from 'clsx';
import React, { ReactElement, ReactNode } from 'react';
import Select, { Props, ControlProps, GroupBase, components } from 'react-select';

export type SearchableSelectAreaProps<
  Option = unknown,
  Group extends GroupBase<Option> = GroupBase<Option>,
> = Props<Option, false, Group> & {
  invalid?: boolean;
  label?: ReactNode;
  errorMessage?: ReactNode;
  readOnly?: boolean;
  size?: 'lg' | 'md' | 'sm';
};

export const SearchableSelectArea = <
  Option = unknown,
  Group extends GroupBase<Option> = GroupBase<Option>,
>({
  invalid,
  size,
  label,
  errorMessage,
  readOnly,
  isDisabled,
  ...props
}: SearchableSelectAreaProps<Option, Group>): ReactElement => (
  <div className={clsx({
    'bp-searchable-select-area': true,
    'bp-searchable-select-area--invalid': invalid,
    'bp-searchable-select-area--readonly': readOnly,
    [`bp-searchable-select-area--${size}`]: size,
  })}
  >
    {label && (
      <div className={clsx({
        'bp-searchable-select-area__label': true,
        'bp-searchable-select-area__label--readonly': readOnly,
        'bp-searchable-select-area__label--disabled': isDisabled,
      })}
      >
        {label}
      </div>
    )}

    <Select
      {...props}
      className="bp-react-select"
      classNamePrefix="bp-react-select"
      closeMenuOnSelect={true}
      isSearchable={true}
      isClearable={false}
      components={{
        DropdownIndicator: null,
      }}
      styles={{
        control: (base) => ({
          ...base,
          boxShadow: 'none',
        }),
      }}
      isDisabled={readOnly || isDisabled}
      placeholder={isDisabled ? '' : props.placeholder}
      menuShouldScrollIntoView={false}
    />

    {errorMessage && (
      <div className="bp-searchable-select-area__error">
        {errorMessage}
      </div>
    )}
  </div>
);
